export default __webpack_public_path__ + "img/icon-flag-fr.asset.dc2eb74a.jpg";